import { PATH } from './path';
import { useEffect } from 'react';
import { useAppSelector } from '../store';
import { Outlet, useNavigate } from 'react-router-dom';

export const ProtectedRoute = () => {
  const userToken = useAppSelector((state) => state.persistValues.userToken);
  const success = useAppSelector((state) => state.user.success);
  const nav = useNavigate();
  useEffect(() => {
    if (!success && !userToken) {
      nav(PATH.LANDING);
    }
  }, [nav, success, userToken]);

  return <Outlet />;
};
